module.exports = __webpack_public_path__ + "img/Accura_logo_design_owl.0cb898f5.svg";